import FileReactionPicker from './FileReactionPicker';

export default FileReactionPicker;
